import React from 'react';
import {Route, Switch, withRouter} from 'react-router-dom'
import PropTypes from 'prop-types'
import Home from '../home'
import NewDashboard from '../dashboard'
import BUDashboard from '../buDashboard'
import withCssSelector from '../../components/css/cssSelector'
import ActiveSession from '../activeSessions'
import TransactionHistory from '../transactionHistory'
import FirebaseCallback from '../firebaseCallback'
import AuthorizedRoute from '../auth'
import ForgotPassword from '../forgotPassword'
import BUSignup from '../buSignup'
import { redirectRoute } from '../accountAppRedirect'
import { ACCOUNT_APP_ADD_VEHICLE, ACCOUNT_APP_LOGIN, ACCOUNT_APP_SIGNUP } from '../../modules/accountApp'
import NewFooter from '../footer'
import Welcome from '../welcome'
import BuThankYou from '../welcome/BuThankYou'
import PaymentAuth from '../paymentAuth'
import {Header, Loader, Segment} from 'semantic-ui-react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {login, logout} from '../../modules/auth'
import BULandingPage from '../bournemouthUnviversity'
import BuHeader from '../headers/buHeader';
import NewHeader from '../headers/newHeader';
import BuFooter from '../footer/buFooter';
import queryString from "query-string";
import Cookies from "universal-cookie";


const PageHeader = (props) => (
    <Header attached as='h2' block color='blue' textAlign='center'>
      {props.title}
    </Header>
);

const cookies = new Cookies();

class App extends React.Component {

  static contextTypes = {
    router: PropTypes.shape({
      history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired
      }).isRequired,
      staticContext: PropTypes.object
    }).isRequired
  }

  render() {

      const { location } = this.props
      let footer = null
      let header = null
      let wrapper = null

      const queryParameters = queryString.parse(window.location.search);
      if (queryParameters.referer === "account") {
        cookies.set("version", "old")
      }
      if (window.location.href.indexOf("bournemouth-university") != -1) {
        footer = <BuFooter />
        header = <BuHeader />
      } else {
        footer = <NewFooter />
        header = <NewHeader />
      }

      if(this.props.initialising) {
        return <Segment basic><Loader active inline='centered' /></Segment>
      }


    return (
      <div>
        <div>
          {header}
        <Route path="/dashboard/active-sessions" component={() => <PageHeader title='Active sessions'/>} />
        <Route path="/dashboard/parking-invoice-history" component={() => <PageHeader title='Parking invoice history'/>} />
        </div>
        <div className={wrapper}>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/login" component={redirectRoute(ACCOUNT_APP_LOGIN)} />
            <Route exact path="/bournemouth-university" component={BULandingPage} />
            <Route exact path="/signup" component={redirectRoute(ACCOUNT_APP_SIGNUP)} />
            <Route exact path="/bournemouth-university/signup" component={BUSignup} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route exact path='/auth-callback' component={FirebaseCallback}/>
            <AuthorizedRoute path="/paymentauth/:id" component={PaymentAuth}/>
            <AuthorizedRoute exact path="/dashboard" component={NewDashboard} />
            <AuthorizedRoute exact path="/bournemouth-university/dashboard" component={BUDashboard} />
            <Route exact path="/dashboard/vehicles/add" component={redirectRoute(ACCOUNT_APP_ADD_VEHICLE)} />
            <AuthorizedRoute exact path="/dashboard/active-sessions/:id" component={ActiveSession} />
            <AuthorizedRoute exact path="/dashboard/parking-invoice-history" component={TransactionHistory} />
            <AuthorizedRoute exact path="/welcome" component={Welcome}/>
            <AuthorizedRoute exact path="/bournemouth-university/welcome" component={BuThankYou}/>

          </Switch>
          </div>
          {/* new or old footer */}
        {footer}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  initialising: state.auth.initialising
})

const mapDispatchToProps = dispatch => bindActionCreators({
  login,
  logout
}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withCssSelector(App)))
